// Export data to Excel spreadsheet
export function ExportSheetToExcel(dataRows:any[][], fileName: string, sheetName: string, options?: ISheetOptions)
{
    const sheetJS = (<any>window).XLSX;
    if (typeof(undefined) === typeof(sheetJS))
    {
        alert("SheetJS not available");
        return;
    }

    /* original data */
    const filename = updateExportFileExtension(fileName);
    const ws_name = sheetName ?? "";

    // Combine the headers and the data
    const data = [];
    for(const row of dataRows)
        data.push(row);
    
    const wb = sheetJS.utils.book_new()
    const ws = sheetJS.utils.aoa_to_sheet(data);

    // Merge cells? 
    if (options?.merge)
    {
        ws["!merges"] = options.merge;
    }
    // Width cells? 
    if (options?.cols)
    {
        ws["!cols"] = options.cols;
    }

    /* add worksheet to workbook */
    sheetJS.utils.book_append_sheet(wb, ws, ws_name); 

    /* write workbook */
    sheetJS.writeFile(wb, filename);
}

function updateExportFileExtension(filename: string) {
    //Check if the filename passed ends with .xls.  If it does, we are going to convert it to .xlsx, since .xls will truncate column data to 255 chars.
    if (filename.endsWith('.xls')) {
        //Replace .xls with .xlsx
        return filename.slice(0, -4) + '.xlsx';
    }
    //Return the filename unchanged if it doesn't end with .xls
    return filename;
}

interface ISheetOptions
{
    merge?: IMergeCellModel[],
    cols?: any[]
}

// Create a cell range
export function CellRange(start: ICellPosModel | CellModel, end: ICellPosModel | CellModel) : IMergeCellModel
{
    return {
        s: { r: start.r, c: start.c },
        e: { r: end.r, c: end.c }
    };
}

// Generate a cell position object
export function CellPosObject(row: number, col: number): ICellPosModel
{
    return { r: row, c:col};
}

interface ICellPosModel{
    r: number,  // Row number (0 based)
    c: number   // Column number (0 based)
}
interface IMergeCellModel
{
    s: ICellPosModel,   // Start
    e: ICellPosModel    // End
}

export class CellModel implements ICellPosModel
{
    public r: number;  // Row number (0 based)
    public c: number;   // Column number (0 based)

    constructor(row: number, col: number)
    {
        this.r = row;
        this.c = col;
    }
}
/* Below are some useful items when exporting to excel sheets */

export enum ExcelDataType
{
    String = "s",
    Date = "d",
    Number = "n" 
} 
export function ExcelRGB(input_color: string) : any {
    return {rgb: input_color};
}
export enum ExcelFormats 
{
    CurrencyFormatRed = "$#,###,##0.00_);[Red]($#,###,##0.00)",
    NumberFormatRed = "#,###,##0.00_);[Red](#,###,##0.00)"
}

export const ExcelStyles : Record <string, any> =
{
    ThinBorder: {top: {style: "thin"}, bottom: {style: "thin"}, left: {style: "thin"}, right: {style: "thin"}},
    HeaderColor: ExcelRGB("c3daf9"),
    FontBold: {bold:true},
    AlignmentCenter: {horizontal: "center"},
    AlignmentRight: {horizontal: "right"},
    AlignmentLeft: {horizontal: "left"},
    MainHeader: {font: {bold: true, sz: "18"}, alignment: {horizontal: "center"}},
    DateHeader: {font: {italic: true, color: {rgb: "a8a8a8"}, sz: "12"}, alignment: {horizontal: "center"}}
}; 

export const ExcelColWidths : Record <string,any> =
{
    Date: {wch:11},
    ID: {wch:10.5},
    Name: {wch:26},
    PaymentType: {wch:20},
    CheckNumber: {wch:27},
    Currency: {wch:13.25},
}